export const LOAD_COOKIE_CONSENT = 'false' === 'true';



// WEBPACK FOOTER //
// ./js/config/cookie-consent.js